import moment from 'moment';
import angular from "angular";

export class MetricsService {
  constructor($http, $rootScope) {
    "ngInject";
    this.$http = $http;
    this.baseUrl = $rootScope.apiHost + "/api/timesheets/metrics";
    this.metrics = {};
    this.monthlyLabels = ['JANUARY', 'FEBRUARY', 'MARCH', 'APRIL', 'MAY', 'JUNE', 'JULY', 'AUGUST', 'SEPTEMBER', 'OCTOBER','NOVEMBER','DECEMBER'];
    this.initVars();
    this.metricsLoaded = false
  }

  initVars() {
    this.yearlyBillableHours = 0;
    this.yearlyNonBillableHours = 0;
    this.lateEntrySubmitsByMonth = [];
    this.yearlyHoursByChargeCode = {};
    this.billableHoursByMonth = [];
    this.nonBillableHoursByMonth = [];
    this.lateRate = 0;
    this.yearlyExpectedHours = 0;
    this.yearlyChargedHours = 0;
    this.selectedYear = moment().year();
  }

  setMetrics(metrics) {
    this.initVars();

    this.metrics = metrics;

    for(let month in metrics) {
      let monthData = metrics[month];

      let index = this.monthlyLabels.indexOf(month);

      this.billableHoursByMonth[index] = monthData.billableHours;
      this.nonBillableHoursByMonth[index] = monthData.nonBillableHours;
      this.lateEntrySubmitsByMonth[index] = monthData.lateTimeEntries;

      this.yearlyExpectedHours+=monthData.expectedHours;
      this.yearlyChargedHours+=monthData.chargedHours;

      this.yearlyBillableHours += monthData.billableHours;
      this.yearlyNonBillableHours += monthData.nonBillableHours;

      for(let a in monthData.hoursByChargeCode){
        let hours = monthData.hoursByChargeCode[a];

        if(!this.yearlyHoursByChargeCode[a]){
          this.yearlyHoursByChargeCode[a] = 0;
        }

        this.yearlyHoursByChargeCode[a]+= hours;
      }
    }

    this.utilizationRate = (this.yearlyBillableHours / (this.yearlyBillableHours + this.yearlyNonBillableHours) * 100).toFixed(0);

  }

  loadMetrics(year) {
    let self = this;
    this.metricsLoaded = false
    return this.getMetricsForUser(year).then((response) => {
      self.setMetrics(response.data);
      this.metricsLoaded = true
    });
  }

  getMetricsForUser(year) {
    return this.$http.get(this.baseUrl+'/'+year,{withCredentials: true});
  }

}


let timesheetMetricsModule = angular.module('timesheetmetrics', []).service('TimesheetMetricsService', MetricsService);
export default timesheetMetricsModule;



// WEBPACK FOOTER //
// ./client/pages/timesheet/services/metrics.service.js